import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DescriptionIcon from "@mui/icons-material/Description";

export interface Document {
  id: string;
  name: string;
  uploadedAt: string;
  documentType?: string;
  s3Bucket?: string | null;
  s3Path?: string | null;
}

export interface DocumentsSectionProps {
  documents: Document[];
  onViewDocument: (documentId: string) => void;
}

export const DocumentsSection: React.FC<DocumentsSectionProps> = ({ documents, onViewDocument }) => {
  if (documents.length === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Uploaded Documents
      </Typography>
      <List disablePadding>
        {documents.map((doc) => (
          <ListItem
            key={doc.id}
            sx={{
              bgcolor: "action.hover",
              borderRadius: 1,
              mb: 1,
              "&:last-child": { mb: 0 },
              display: "flex",
              justifyContent: "space-between",
            }}
            secondaryAction={
              <Button variant="text" size="small" onClick={() => onViewDocument(doc.id)}>
                View
              </Button>
            }
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <DescriptionIcon color="action" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Box>
                  <Typography variant="body1" fontWeight={500}>
                    {doc.name}
                  </Typography>
                  {doc.documentType && (
                    <Typography variant="caption" color="text.secondary">
                      {doc.documentType}
                    </Typography>
                  )}
                </Box>
              }
              secondary={`Uploaded ${new Date(doc.uploadedAt).toLocaleDateString()}`}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default DocumentsSection;
